import React__default, { useState } from 'react';
import { DrawerBackdrop } from './components/DrawerBackdrop/DrawerBackdrop.js';
import { DrawerContent } from './components/DrawerContent/DrawerContent.js';
import { DrawerDivider } from './components/DrawerDivider/DrawerDivider.js';
import { DrawerHeader } from './components/DrawerHeader/DrawerHeader.js';
import { DrawerOverlay } from './components/DrawerOverlay/DrawerOverlay.js';
import { DrawerTitle } from './components/DrawerTitle/DrawerTitle.js';
import { DrawerProvider } from './context/DrawerContext.js';

const Drawer = ({ children , direction  })=>{
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ React__default.createElement(DrawerProvider, {
        direction: direction,
        isOpen: isOpen,
        setIsOpen: setIsOpen
    }, children);
};
Drawer.Overlay = DrawerOverlay;
Drawer.Backdrop = DrawerBackdrop;
Drawer.Header = DrawerHeader;
Drawer.Content = DrawerContent;
Drawer.Divider = DrawerDivider;
Drawer.Title = DrawerTitle;
var Drawer$1 = Drawer;

export { Drawer$1 as default };
//# sourceMappingURL=Drawer.js.map
